import { positionChip } from '../lib/oura';
import { cn } from '../lib/cn';

/**
 * A Google position is DETERMINISTIC, so it renders as a solid chip: #3.
 * Green top three, amber four to ten, red beyond, grey when absent (§4).
 * Solid and square-ish on purpose — the opposite of <DotStrip>'s dots.
 */
export function PositionChip({ position }: { position: number | null }) {
  const { label, className } = positionChip(position);
  return (
    <span
      className={cn(
        'inline-grid min-w-[28px] place-items-center rounded-md border px-1.5 py-0.5 text-xs font-semibold tabular-nums',
        className,
      )}
    >
      {label}
    </span>
  );
}
